import CustomInput from '../TransactionForm/CustomInput';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import ErrorContainer from '../TransactionForm/ErrorContainer';
import JunoButton from './JunoButton';
import CustomSelect from './CustomSelect';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const JunoForm = ({
    fields,
    handleChange,
    errors,
    formData,
    bottom,
    loading,
    disabled,
    onBottomClick = () => {},
    bottomText = 'save',
    buttonClassName,
}) => {
    return (
        <div className="h-full ">
            <div className="mb-4">
                {fields.map(props => {
                    let field = props.visibilityKey;
                    return (
                        <div key={props.name}>
                            <div className="relative">
                                {props.type == 'select' ? (
                                    <CustomSelect
                                        {...props}
                                        key={props}
                                        onChange={selected =>
                                            handleChange(null, 'select', props.name, selected)
                                        }
                                        className="my-6"
                                        // required={props.isRequired}
                                    />
                                ) : (
                                    <CustomInput
                                        {...props}
                                        key={props}
                                        onChange={handleChange}
                                        className="!pr-11"
                                        // required={props.isRequired}
                                    />
                                )}
                                {props.visibileIcon ? (
                                    <div
                                        className="absolute right-3 bottom-3 cursor-pointer text-balanceCard-manage"
                                        onClick={() => handleChange(null, 'bool', field)}>
                                        {formData[field] ? (
                                            <VisibilityOutlinedIcon />
                                        ) : (
                                            <VisibilityOffOutlinedIcon />
                                        )}
                                    </div>
                                ) : null}
                            </div>
                            {errors?.[props.name] ? (
                                <ErrorContainer
                                    message={errors[props.name]}
                                    id={`${props.name}-error`}
                                />
                            ) : null}
                        </div>
                    );
                })}
            </div>
            {bottom ? (
                bottom()
            ) : (
                <JunoButton
                    loading={loading}
                    disabled={disabled}
                    dataE2e={bottomText}
                    onClick={onBottomClick}
                    className={clsx(
                        buttonClassName,
                        ' fixed bottom-0 mt-[0px] md:mt-12 mb-11 md:mb-0 left-0 right-0 max-w-[90%] w-[90%] mx-auto !md:mt-12 md:w-full md:max-w-full md:relative md:bottom-0',
                    )}>
                    {bottomText}
                </JunoButton>
            )}
        </div>
    );
};

JunoForm.propTypes = {
    fields: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            type: PropTypes.string,
            visibilityKey: PropTypes.string,
            visibileIcon: PropTypes.bool,
            isRequired: PropTypes.bool,
        }),
    ).isRequired,
    handleChange: PropTypes.func.isRequired,
    errors: PropTypes.object,
    formData: PropTypes.object.isRequired,
    bottom: PropTypes.func,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    onBottomClick: PropTypes.func,
    bottomText: PropTypes.string,
    buttonClassName: PropTypes.string,
    autoComplete: PropTypes.string,
};

export default JunoForm;
